import { axiosInstance } from "../App";

export const getDashboardByYearAndCollab = (year, collab) => {
  return axiosInstance
    .get("dashboard", { params: { year, collab } })
    .then((response) => response.data);
};
